/**
 * Реальный оборот со своей цепи, не мок: aggregator.py на
 * liquorice-dashboard-backend раз в 1с считает из dashboard.onchain_fills
 * (fills_ingest.py — TradeOrder на сеттлменте, сверенный по rfq_id с тем, что
 * реально котировали мы, а не старый бот на том же адресе) и льёт в тот же
 * бакет. «All» — только с момента, когда этот конвейер запустился: бесплатный
 * RPC режет eth_getLogs дальше ~50 блоков как архивный запрос, глубокого
 * бэкафилла нет.
 *
 * Оборот суммирует ВСЕ живые алгоритмы на этом адресе, не только один: index
 * 1 — mm-v2 на liquorice-mm-2 (collector.py), index 2 — эксперимент
 * flat-price на liquorice-mm-1 (mm1_ingest.py, читает rfq_history.csv через
 * docker exec — у контейнера нет примонтированного тома, поэтому только
 * пуллинг наружу переживает передеплой). byIndex — разбивка для дальнейших
 * index'ов, не нужно менять код при появлении ещё одного.
 */
import { useEffect, useState } from 'react'

export interface VolumePoint {
  time: number
  value: number
}

export interface VolumeByIndex {
  index: number
  fills: number
  usd: number
}

export interface LiveVolumeData {
  hourly24h: VolumePoint[]
  daily30d: VolumePoint[]
  dailyAll: VolumePoint[]
  totalFills: number
  totalUsdAllTime: number
  byIndex: VolumeByIndex[]
  generatedAtMs: number
}

const CHART_BASE_URL = import.meta.env.VITE_LIVE_CHART_BASE_URL as string | undefined

export function useLiveVolume(): LiveVolumeData | null {
  const [data, setData] = useState<LiveVolumeData | null>(null)

  useEffect(() => {
    if (!CHART_BASE_URL) return
    let stopped = false
    let timer: number | undefined
    const url = `${CHART_BASE_URL}/chart-volume.json`

    const tick = async () => {
      if (stopped) return
      try {
        const res = await fetch(`${url}?_=${Date.now()}`, { cache: 'no-store' })
        if (res.ok) setData(await res.json())
      } catch (err) {
        console.error('[live] volume fetch failed', err)
      } finally {
        if (!stopped) timer = window.setTimeout(tick, 5000)
      }
    }
    tick()
    return () => {
      stopped = true
      if (timer !== undefined) window.clearTimeout(timer)
    }
  }, [])

  return data
}
